import script from "./DocumentView.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentView.vue?vue&type=script&setup=true&lang=js"

import "./DocumentView.vue?vue&type=style&index=0&id=6e936789&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e936789"]])

export default __exports__